import { render, staticRenderFns } from "./GenericAttributesCard.vue?vue&type=template&id=1442b86f&scoped=true&"
import script from "./GenericAttributesCard.vue?vue&type=script&lang=js&"
export * from "./GenericAttributesCard.vue?vue&type=script&lang=js&"
import style0 from "./GenericAttributesCard.vue?vue&type=style&index=0&id=1442b86f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1442b86f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VCardTitle,VContainer,VIcon,VSubheader})
